import type { ReactNode } from "react";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionTitle({ eyebrow, title, description, action }: SectionTitleProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-1 h-4 rounded-full bg-accent-500" />
            <span className="text-xs md:text-sm font-medium tracking-widest text-accent-700">
              {eyebrow}
            </span>
          </div>
        )}
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="text-sm text-foreground-600 mt-2 max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}